// Pulling in the store ahead of time to prevent a circular dependency between auth-tokens and stores
// Importing the store ahead of time puts the store into the webpack cache so that it can be used in auth-tokens and any where else that needs it
// eslint-disable-next-line no-unused-vars
import heroCarousel from './modules/HeroCarousel';
import searchReveal from './modules/SearchReveal';
import toggler from './modules/Toggler';
import slider from './modules/slider';
import login from './pages/login';
import productDetailPage from './pages/productDetail';
import prodCarousel from './modules/ProductCarousel';
import collections from './modules/Collections';
import facets from './modules/facets';
import deliveryDetails from './pages/deliveryDetails';
import orderConfirmation from './pages/orderConfirmation';
import player from './modules/Players';
import selectBox from './modules/SelectBox';
import loadingIndicator from './modules/loadingIndicator';
import popup from './modules/Popup';
import requestReturnLabel from './pages/requestReturnLabel';
import emailSignup from './modules/EmailSignup';
import accountProfile from './modules/accountProfile';
import storeNewsletterSignup from './modules/storeNewsletterSignup';
import storeResults from './modules/storeresults';
import searchBoxComponent from './modules/search-box-component';
import storeSearch from './modules/store-search';
import previewJs from './modules/previewjs';
import tagManagerJs from './modules/tagmanagerjs';
import geoPrompt from './modules/geoPrompt';
import newsletterPage from './modules/acc.newsletter';
import searchResultHandler from './modules/searchResultHandler';
import {updateASMHeader} from './utils/asmAdjustments';
import {vueConfig, unmountOldApps, reMountVue} from './vueConfig';
import {handleKioskLinks} from '@/composables/kiosk-links';

// Vue Components
import SearchContainer from '@/components/containers/search/SearchContainer';
import PlpFacetRefinementsWrapper from '@/components/containers/plp/b2c/PlpFacetRefinementsWrapper.vue';
import ProductCardItem from '@/components/containers/plp/ProductCardItem';
import ProductLabelYear from '@/components/containers/plp/ProductCard/ProductLabelYear';
import TrekLink from '@/components/TrekLink';
import ProductLabelGroup from '@/components/ProductLabelGroup';
import ProductCompareButton from '@/components/compare/ProductCompareButton';
import SearchContentListItem from '@/components/search/SearchContentListItem.vue';
import {PdlCollapse, PdlCollapseItem} from '@pedal/pdl-collapse';
import {PdlTabs} from '@pedal/pdl-tabs';
import {PdlButton} from '@pedal/pdl-button';
import {PdlIcon} from '@pedal/pdl-icon';
import {PdlDrawer} from '@pedal/pdl-drawer';
import {PdlSwatch, PdlSwatchGroup} from '@pedal/pdl-swatch';
import {PdlLink} from '@pedal/pdl-link';
import {PdlLabel, PdlLabelGroup} from '@pedal/pdl-label';
import ImageComponent from '@/components/ImageComponent';

//Misc
import editorialHighlightComponent from '@/modules/editorialHighlightComponent';
import accordionComponent from '@/modules/accordionComponent.js';

// Import styling
import '@sassRoot/screen.scss';
import '@sassRoot/b2b.scss';

// Initialize Vue
vueConfig();

window.addEventListener('load', () => handleKioskLinks());

function addTabRemountListeners(tabName) {
  window.addEventListener(`unmount-vue-dynamic-content-${tabName}`, () => unmountOldApps(tabName));
  window.addEventListener(`init-vue-dynamic-content-${tabName}`, () => {
    const domElements = document.querySelectorAll(`[data-vue-dynamic-content-${tabName}]`);
    if (!domElements || !domElements.length) {
      return;
    }

    reMountVue(
      domElements,
      {
        SearchContainer,
        PlpFacetRefinementsWrapper,
        ProductCardItem,
        TrekLink,
        ProductLabelGroup,
        PdlCollapse,
        PdlTabs,
        PdlCollapseItem,
        PdlSwatch,
        PdlLink,
        PdlSwatchGroup,
        ProductCompareButton,
        ProductLabelYear,
        PdlLabel,
        PdlLabelGroup,
        PdlIcon,
        PdlButton,
        PdlDrawer,
        SearchContentListItem,
        ImageComponent,
      },
      tabName
    );
  });
}

addTabRemountListeners('product');
addTabRemountListeners('archive');
addTabRemountListeners('articles');
addTabRemountListeners('other-content');

window.loadNonCriticalCSS = (nonCriticalCSSPath) => {
  // Create CSS link tag to be inserted in head
  let nonCriticalCSSLink = document.createElement('link');
  nonCriticalCSSLink.rel = 'stylesheet';
  nonCriticalCSSLink.href = nonCriticalCSSPath;
  nonCriticalCSSLink.type = 'text/css';

  nonCriticalCSSLink.onload = () => {
    // Remove critical CSS after link has loaded
    let criticalCSSElement = document.getElementById('criticalCSS');
    if (criticalCSSElement) {
      criticalCSSElement.remove();
    }

    // Used by automation to determine when to start testing after page has stabilized
    window.isCSSLoaded = true;
  };

  // Find the critical css (located at the head) and insert the link tag right next to it
  let criticalCSSElement = document.getElementById('criticalCSS');
  criticalCSSElement.insertAdjacentElement('afterend', nonCriticalCSSLink);

  // Ensures the owl carousel displays correctly after noncritical css loads.
  if (window.sliderRefs && window.sliderRefs.length) {
    window.sliderRefs.forEach(function (slider) {
      $(slider).trigger('to.owl.carousel', 0);
    });
  }
};

$(document).ready(() => {
  $(window).on('load', () => {
    $(window).trigger('resize');

    //Check if editorialHighLightComponet is present in page
    if ($('.js-editorial-highlight-component').length) {
      editorialHighlightComponent();
    }

    //Check if accordionComponent is present on page
    if ($('.accordion-component').length) {
      accordionComponent();
    }
  });

  const element = $(document);

  // adding a global loading indicator
  window.loadingIndicator = loadingIndicator();

  const sliders = element.find('[data-owl-slider]');
  window.sliderRefs = [];
  sliders.each((i, s) => {
    window.sliderRefs.push(slider($(s)));
  });

  const carousel = $('[data-hero-carousel]');
  if (carousel.length) {
    heroCarousel(carousel);
  }

  searchReveal(element);

  const togglers = element.find('[data-toggler]');
  togglers.each((i, t) => {
    toggler($(t));
  });

  selectBox();
  player();

  $('[data-popup-reveal]').each((i, p) => {
    popup($(p));
  });

  $('#goToTop').click(() => {
    $('html, body').animate(
      {
        scrollTop: $($('#page')).offset().top,
      },
      1000
    );
  });

  if ($('.page-login').length || $('.template-pages-MultiStepCheckoutSummaryPageTemplate').length) {
    login();
  }

  if ($('.page-productDetails').length || $('.page-nonBikeProductDetails').length) {
    productDetailPage(element);
  }

  const productCarousel = $('[data-product-carousel]');
  if (productCarousel.length) {
    prodCarousel(productCarousel);
  }

  const collectionsHighlights = $('[data-collection-highlights]');
  if (collectionsHighlights.length) {
    collections(element);
  }

  const productList = $('[data-product-list]');
  if (productList.length) {
    facets(productList);
    searchResultHandler(productList);
  }

  const articleList = $('[data-article-list]');
  if ($('.page-articlesB2B').length) {
    facets(articleList);
    searchResultHandler(articleList);
  }

  if ($('.page-multiStepCheckoutSummaryPage').length) {
    deliveryDetails();
  }

  if ($('.page-orderConfirmation').length) {
    orderConfirmation();
  }

  if ($('.page-requestReturnLabel').length) {
    requestReturnLabel();
  }

  $('[data-loading-mask]').addClass('hide');
  $('.loading-masked').fadeTo(1, 1);

  emailSignup(element);
  storeNewsletterSignup(element);
  accountProfile(element);

  if ($('#currentLocale').val() !== 'zh_CN') {
    searchBoxComponent(element);
  }

  if ($('#storesearch_js_id').length) {
    storeSearch(element);
  }

  if ($('#preview_id_js').length) {
    previewJs(element);
  }

  if ($('#isTagManagercode_js').length) {
    tagManagerJs(element);
  }

  if ($('#storeresults_js_id').length) {
    storeResults(element);
  }

  if ($('.geo-prompt-modal').length) {
    geoPrompt(element);
  }

  if ($('#newsletter_submit').length) {
    newsletterPage(element);
  }

  // Footer hide shop links in kiosk mode
  if ($('#isKioskMode').length) {
    $('#footerRetailerLink').parent().hide();
    $('#retailersFooterLinkElectra').parent().hide();
  }

  updateASMHeader();
});
